import React, { useEffect, useState } from 'react';
import { SidePanelFilter } from '@getsynapse/design-system';
import { fetchFieldsUsedInProjects } from 'state/CustomFields/customFieldsSlice';
import { useDispatch } from 'react-redux';
import BudgetFiltersForm from './BudgetFiltersForm';
import { BudgetFilters } from '../../../../../../utils/constants/budget';

export type Props = {
  open: boolean;
  onUpdateFilters: (filters: BudgetFilters) => void;
  onClose: () => void;
  filters?: BudgetFilters;
  selectedBudgetId?: string;
};

const BudgetFiltersSidePanel: React.FC<Props> = ({
  open,
  filters = {},
  onUpdateFilters,
  onClose,
  selectedBudgetId,
}) => {
  const dispatch = useDispatch();

  const [appliedFilters, setAppliedFilters] = useState<BudgetFilters>(
    {} as BudgetFilters
  );
  const [canApplyFilters, setCanApplyFilters] = useState<boolean>(false);
  const [showCustomFilters, setShowCustomFilters] = useState(false);
  const [showAnimation, setShowAnimation] = useState(false);

  useEffect(() => {
    if (filters) {
      setAppliedFilters(filters as BudgetFilters);
    }
  }, [filters]);

  useEffect(() => {
    dispatch(fetchFieldsUsedInProjects());
  }, [dispatch]);

  const handleUpdateFilters = (
    updatedFilters: BudgetFilters,
    isClosing?: boolean
  ) => {
    setAppliedFilters(updatedFilters);
    if (!isClosing) {
      setCanApplyFilters(true);
    }
  };

  const handleApplyFilters = () => {
    onUpdateFilters(appliedFilters);
    setCanApplyFilters(false);
  };

  const handleClearAllFilters = () => {
    onUpdateFilters({} as BudgetFilters);
    setAppliedFilters({} as BudgetFilters);
    setCanApplyFilters(false);
  };

  return (
    <SidePanelFilter
      open={open}
      onClose={() => {
        onClose();
        setShowCustomFilters(false);
        setShowAnimation(false);
        handleUpdateFilters(filters as BudgetFilters, true);
      }}
      appliedFiltersCount={
        Object.keys(appliedFilters).filter((val) => val !== 'budgetId').length
      }
      canApplyFilters={canApplyFilters}
      onClearAllFilters={handleClearAllFilters}
      onApplyFilters={handleApplyFilters}
      title={`${showCustomFilters ? '' : 'Filters'}`}
    >
      <BudgetFiltersForm
        selectedBudgetId={selectedBudgetId}
        appliedFilters={appliedFilters as BudgetFilters}
        onUpdateFilters={handleUpdateFilters}
        showAnimation={showAnimation}
      />
    </SidePanelFilter>
  );
};

export default BudgetFiltersSidePanel;
